import { render, staticRenderFns } from "./dingbu.vue?vue&type=template&id=d196ea1c&scoped=true&"
import script from "./dingbu.vue?vue&type=script&lang=js&"
export * from "./dingbu.vue?vue&type=script&lang=js&"
import style0 from "./dingbu.vue?vue&type=style&index=0&id=d196ea1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d196ea1c",
  null
  
)

export default component.exports